var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"svg-icon",attrs:{"height":_vm.height,"width":_vm.width,"fill":_vm.color ? _vm.color : '#000'}},[_c('use',{attrs:{"href":'#icon-' + _vm.variant}})])
}
var staticRenderFns = []

export { render, staticRenderFns }